import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabservicepune() {



  const cardData = {




keyword: "Corporate Cab Service Pune",

headingDescription: "Garud Cab Service provides professional and reliable Corporate Cab Service in Pune for companies, IT firms, startups, corporate offices, business travelers, executives, and employees. Our chauffeur-driven sedans and premium vehicles are suitable for daily employee transportation, airport transfers, client meetings, business conferences, office transfers, intercity business travel, and scheduled corporate journeys. With experienced professional drivers, clean and well-maintained vehicles, flexible pickup and drop arrangements, timely service, transparent pricing, and 24/7 customer assistance, Garud Cab Service helps businesses manage comfortable and dependable employee and executive transportation across Pune and nearby business destinations.",

topPlaces: [
  {
    title: "Mumbai",
    description: "Mumbai is a major corporate and commercial destination frequently visited from Pune for business meetings, client appointments, conferences, office work, and executive travel. Companies can arrange comfortable corporate cabs for employees and business professionals traveling between Pune and Mumbai. Garud Cab Service provides chauffeur-driven vehicles with flexible pickup locations, one-way and round-trip options, and convenient scheduling for corporate requirements."
  },
  {
    title: "Nashik",
    description: "Nashik is an important business and industrial destination from Pune, attracting professionals for corporate meetings, factory visits, conferences, and commercial activities. A private corporate cab provides convenient door-to-door transportation for employees and executives traveling between the two cities. Garud Cab Service offers comfortable vehicles, experienced chauffeurs, flexible travel schedules, and customized corporate transportation plans."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad, also known as Chhatrapati Sambhajinagar, is an important industrial, commercial, and tourism destination in Maharashtra. Corporate travelers from Pune frequently visit the city for business meetings, industrial work, client visits, and professional events. Garud Cab Service provides reliable chauffeur-driven corporate cabs with comfortable seating, luggage space, and flexible one-way or return travel arrangements."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a major commercial and industrial city in southern Maharashtra and is regularly visited from Pune for business travel, corporate meetings, manufacturing work, and client appointments. Companies can book private corporate cabs for employees and executives requiring comfortable intercity transportation. Garud Cab Service provides professional drivers, clean vehicles, and flexible pickup and drop facilities."
  },
  {
    title: "Satara",
    description: "Satara is an important destination for industrial, commercial, and business travel from Pune, with several companies and manufacturing activities in and around the region. Corporate employees can use a private cab for meetings, site visits, inspections, and official work. Garud Cab Service offers comfortable chauffeur-driven transportation with convenient scheduling and customized travel plans."
  },
  {
    title: "Goa",
    description: "Goa is a popular long-distance destination from Pune for corporate retreats, business meetings, conferences, events, and extended professional travel. Companies can arrange comfortable cabs for executives, employees, and small corporate groups traveling together. Garud Cab Service provides private chauffeur-driven transportation with one-way and round-trip options and flexible travel arrangements."
  },
  {
    title: "Ahmednagar",
    description: "Ahmednagar is an important industrial and commercial destination accessible from Pune and is visited by professionals for factory work, business meetings, site inspections, and corporate assignments. A private cab provides convenient transportation for employees and executives who need direct travel between offices and industrial locations. Garud Cab Service offers reliable corporate cab bookings with professional chauffeurs and flexible schedules."
  },
  {
    title: "Solapur",
    description: "Solapur is a significant commercial and industrial city in Maharashtra and is visited from Pune for business meetings, textile-related work, industrial activities, and professional assignments. Corporate travelers can choose a private chauffeur-driven cab for a comfortable long-distance journey. Garud Cab Service provides suitable vehicles, convenient pickup arrangements, and one-way or round-trip corporate travel options."
  },
  {
    title: "Shirdi",
    description: "Shirdi is a popular destination from Pune for corporate groups, employee trips, family functions, and business travelers combining official work with religious visits. Companies and small groups can book a comfortable cab for direct travel or a customized return itinerary. Garud Cab Service provides chauffeur-driven vehicles with flexible timings and convenient pickup and drop arrangements."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill destination from Pune and is frequently selected for corporate outings, team trips, business retreats, and employee gatherings. Comfortable private transportation is useful when companies are traveling with colleagues and luggage. Garud Cab Service provides chauffeur-driven corporate cabs with flexible travel schedules, suitable vehicles, and customized round-trip arrangements."
  }
],



"services": [
{
"name": "Corporate Cab Service Pune",
"description": "Book Corporate Cab Service Pune for reliable employee and business transportation with professional chauffeurs and well-maintained AC vehicles. The service is suitable for office commuting, client meetings, airport transfers, employee pickup and drop, corporate events, business travel, and scheduled company transportation requirements."
},
{
"name": "Business Cab Service Pune",
"description": "Choose Business Cab Service Pune for comfortable and dependable transportation for professionals, executives, clients, and corporate teams. Enjoy convenient pickup and drop, experienced chauffeurs, clean AC vehicles, flexible scheduling, airport transfers, office travel, meetings, and intercity business journeys."
},
{
"name": "Employee Transportation Pune",
"description": "Arrange Employee Transportation Pune for convenient daily travel between employees' pickup locations and offices. Professional chauffeurs, comfortable AC vehicles, scheduled routes, flexible shift timings, and organized pickup and drop arrangements make the service suitable for companies managing regular employee transportation."
},
{
"name": "Office Cab Service Pune",
"description": "Book Office Cab Service Pune for comfortable and scheduled employee transportation to and from workplaces. The service supports daily office commuting, multiple pickup points, shift-based travel, corporate routes, and reliable chauffeur-driven transportation with suitable sedan, SUV, and larger vehicle options."
},
{
"name": "Corporate Taxi Pune",
"description": "Choose Corporate Taxi Pune for professional chauffeur-driven transportation for employees, executives, clients, and business visitors. Enjoy comfortable AC travel for office transfers, meetings, airport transportation, corporate events, local travel, and planned outstation business journeys."
},
{
"name": "Company Cab Service Pune",
"description": "Book Company Cab Service Pune for organized transportation solutions designed for businesses and their employees. Professional drivers, comfortable vehicles, scheduled pickup and drop facilities, office commute support, airport transfers, and flexible travel arrangements help companies manage regular corporate mobility requirements."
},
{
"name": "Staff Transportation Pune",
"description": "Arrange Staff Transportation Pune for convenient and dependable employee mobility with scheduled pickup and drop services. The service is suitable for companies operating regular office shifts, multiple employee routes, early or late working hours, and daily transportation requirements across Pune."
},
{
"name": "Corporate Cab Booking Pune",
"description": "Make Corporate Cab Booking Pune for scheduled transportation of employees, executives, clients, and business visitors. Select suitable vehicles according to passenger requirements and enjoy professional chauffeur service, convenient pickup, airport transfers, office travel, meetings, and corporate event transportation."
},
{
"name": "Executive Cab Service Pune",
"description": "Choose Executive Cab Service Pune for comfortable and professional transportation for senior executives, business guests, clients, and corporate travelers. Enjoy premium AC vehicles, experienced chauffeurs, convenient pickup and drop, airport transfers, business meetings, hotel transfers, and intercity corporate travel."
},
{
"name": "Corporate Travel Cab Pune",
"description": "Book Corporate Travel Cab Pune for reliable transportation during business meetings, conferences, client visits, office travel, airport transfers, and corporate events. Flexible vehicle choices, professional chauffeurs, scheduled pickups, and comfortable AC interiors make business travel convenient across Pune and nearby destinations."
},
{
"name": "Monthly Cab Service Pune",
"description": "Choose Monthly Cab Service Pune for businesses requiring regular chauffeur-driven transportation throughout the month. Flexible travel arrangements can support employee commuting, office transfers, executive travel, client visits, airport transportation, and recurring corporate mobility requirements."
},
{
"name": "Employee Pickup Drop Pune",
"description": "Book Employee Pickup Drop Pune for scheduled transportation between employees' homes and workplaces. Professional chauffeurs, comfortable AC vehicles, planned routes, convenient pickup points, and flexible shift timings make the service suitable for companies managing regular staff transportation."
},
{
"name": "Corporate Fleet Pune",
"description": "Choose Corporate Fleet Pune for organized vehicle solutions supporting employee transportation, executive travel, client movement, airport transfers, and business requirements. Companies can select suitable sedan, MUV, SUV, and premium vehicle categories according to passenger capacity and corporate travel needs."
},
{
"name": "Premium Corporate Cab Pune",
"description": "Book Premium Corporate Cab Pune for executive and business travel requiring enhanced comfort, professional chauffeur service, and well-maintained AC vehicles. The service is suitable for senior management, clients, corporate guests, airport transfers, business meetings, hotels, events, and intercity travel."
},
{
"name": "Office Commute Cab Pune",
"description": "Choose Office Commute Cab Pune for convenient daily transportation between employee residences and workplaces. Scheduled pickup and drop, professional drivers, comfortable AC vehicles, multiple route options, and flexible shift-based travel help companies provide dependable office commuting facilities."
},
{
"name": "Corporate Cab Services in Pune",
"description": "Book Corporate Cab Services in Pune for comprehensive business transportation covering employee commuting, executive travel, client transfers, airport pickups, office routes, meetings, and corporate events. Choose comfortable chauffeur-driven vehicles according to passenger capacity, travel schedule, and business requirements."
},
{
"name": "Corporate Taxi Service Pune",
"description": "Choose Corporate Taxi Service Pune for reliable transportation for employees, executives, clients, and business visitors. Professional chauffeurs and clean AC vehicles provide convenient travel for office commuting, airport transfers, meetings, hotel transportation, corporate events, and planned outstation journeys."
},
{
"name": "Employee Transportation Service Pune",
"description": "Book Employee Transportation Service Pune for organized daily staff movement with scheduled pickup and drop facilities. The service can support different office shifts, multiple employee locations, corporate routes, and regular workplace transportation with comfortable AC vehicles and professional chauffeurs."
},
{
"name": "Corporate Car Rental Pune",
"description": "Hire Corporate Car Rental Pune with professional chauffeurs for business meetings, executive transportation, client visits, airport transfers, conferences, corporate events, and intercity travel. Choose from comfortable sedan, MUV, SUV, and premium vehicle options according to passenger and luggage requirements."
},
{
"name": "Office Cab Service Pimpri Chinchwad",
"description": "Book Office Cab Service Pimpri Chinchwad for dependable employee transportation between residential areas, offices, industrial locations, and business parks. Scheduled pickup and drop, professional chauffeurs, comfortable AC vehicles, and flexible shift arrangements make the service suitable for regular corporate commuting."
},
{
"name": "Business Cab Service Pimpri Chinchwad",
"description": "Choose Business Cab Service Pimpri Chinchwad for comfortable transportation of executives, employees, clients, and corporate visitors. The service supports office travel, meetings, airport transfers, hotel pickups, business events, and outstation journeys with professional chauffeur-driven vehicles."
},
{
"name": "Corporate Travel Service Pune",
"description": "Book Corporate Travel Service Pune for convenient transportation during business meetings, conferences, client visits, airport transfers, corporate events, and employee travel. Enjoy flexible scheduling, professional chauffeurs, comfortable AC vehicles, and suitable options for local and intercity corporate transportation."
},
{
"name": "Staff Pickup and Drop Service Pune",
"description": "Arrange Staff Pickup and Drop Service Pune for scheduled employee transportation between homes and workplaces. The service is suitable for companies with regular office shifts and multiple employee routes, providing comfortable AC vehicles, professional chauffeurs, planned pickups, and convenient destination drops."
},
{
"name": "Corporate Cab Booking Pune",
"description": "Make Corporate Cab Booking Pune for employees, executives, clients, and business guests requiring scheduled private transportation. Select suitable vehicle categories for office commuting, airport transfers, meetings, corporate events, hotel transportation, and outstation business travel."
},
{
"name": "Best Corporate Cab Service in Pune",
"description": "Choose Best Corporate Cab Service in Pune for dependable chauffeur-driven transportation designed around business travel and employee mobility. Enjoy comfortable AC vehicles, scheduled pickup and drop, professional drivers, airport transfers, executive travel, office commuting, and flexible corporate transportation arrangements."
},
{
"name": "Employee Transport Service Near Me Pune",
"description": "Find Employee Transport Service Near Me Pune for convenient staff transportation close to residential and workplace locations. Scheduled pickup and drop facilities, professional chauffeurs, comfortable vehicles, and flexible routes make the service suitable for companies managing daily employee commuting requirements."
},
{
"name": "Office Pickup and Drop Cab Pune",
"description": "Book Office Pickup and Drop Cab Pune for reliable daily transportation between employee residences and offices. The service supports scheduled routes, multiple pickup locations, different working shifts, professional chauffeurs, and comfortable AC vehicles for convenient corporate commuting."
},
{
"name": "Corporate Taxi Booking Pune",
"description": "Reserve Corporate Taxi Booking Pune for business meetings, employee transportation, airport transfers, client visits, executive travel, and corporate events. Choose comfortable chauffeur-driven vehicles according to your passenger requirements and enjoy convenient scheduled pickup and destination drop facilities."
},
{
"name": "Business Travel Cab Service Pune",
"description": "Choose Business Travel Cab Service Pune for comfortable transportation during meetings, conferences, client visits, airport transfers, hotel stays, and corporate events. Professional chauffeurs, clean AC vehicles, flexible scheduling, and local or outstation travel options support efficient business mobility."
},
{
"name": "Corporate Airport Cab Pune",
"description": "Book Corporate Airport Cab Pune for reliable airport pickup and drop transportation for employees, executives, clients, and business guests. Enjoy scheduled transfers, luggage-friendly vehicles, professional chauffeurs, comfortable AC interiors, and convenient transportation between Pune Airport, offices, hotels, and business locations."
},
{
"name": "Cab Service for Companies Pune",
"description": "Choose Cab Service for Companies Pune for organized transportation supporting employee commuting, executive travel, client movement, airport transfers, business meetings, and corporate events. Flexible vehicle options and professional chauffeur service help businesses manage regular and occasional transportation requirements."
},
{
"name": "Staff Transportation in Pune",
"description": "Arrange Staff Transportation in Pune for convenient employee movement between homes, offices, industrial areas, and business locations. Scheduled pickup and drop, comfortable AC vehicles, professional chauffeurs, and flexible shift-based routes make the service suitable for companies with regular staff travel needs."
},
{
"name": "Corporate Cab Service Pimpri Chinchwad",
"description": "Book Corporate Cab Service Pimpri Chinchwad for employee, executive, client, and business transportation across PCMC. The service provides comfortable chauffeur-driven AC vehicles for office commuting, airport transfers, meetings, industrial visits, corporate events, and scheduled outstation travel."
},
{
"name": "Corporate Taxi Service PCMC",
"description": "Choose Corporate Taxi Service PCMC for reliable transportation for employees, executives, clients, and corporate visitors across Pimpri Chinchwad. Enjoy professional chauffeur service, comfortable AC vehicles, scheduled pickup and drop, airport transfers, office travel, business meetings, and intercity transportation."
},
{
"name": "Employee Transport Service Pimpri Chinchwad",
"description": "Arrange Employee Transport Service Pimpri Chinchwad for dependable daily staff commuting between residential areas and workplaces. Flexible routes, scheduled pickup and drop, professional chauffeurs, comfortable AC vehicles, and shift-based transportation support companies across PCMC."
},
{
"name": "Office Cab Service Pimpri Chinchwad",
"description": "Book Office Cab Service Pimpri Chinchwad for convenient employee transportation to and from offices, industrial areas, IT locations, and business parks. The service supports regular office shifts with scheduled pickup, professional chauffeurs, comfortable AC vehicles, and flexible route arrangements."
},
{
"name": "Corporate Car Rental PCMC",
"description": "Hire Corporate Car Rental PCMC with professional chauffeurs for executives, employees, clients, airport transfers, business meetings, industrial visits, and corporate events. Select sedan, MUV, SUV, or premium vehicles according to passenger capacity, luggage requirements, and travel plans."
},
{
"name": "Business Cab Service Pimpri Chinchwad",
"description": "Choose Business Cab Service Pimpri Chinchwad for comfortable corporate transportation for executives, employees, clients, and business visitors. The service is suitable for office travel, meetings, airport transfers, hotels, industrial locations, corporate events, and outstation business journeys."
},
{
"name": "Staff Transportation Service PCMC",
"description": "Book Staff Transportation Service PCMC for scheduled employee pickup and drop across Pimpri Chinchwad. Comfortable AC vehicles, professional chauffeurs, flexible routes, multiple pickup points, and shift-based travel arrangements help companies manage dependable daily staff transportation."
},
{
"name": "Corporate Cab Booking Pimpri Chinchwad",
"description": "Make Corporate Cab Booking Pimpri Chinchwad for scheduled employee, executive, client, and business transportation. Choose suitable vehicles for office commuting, airport transfers, meetings, corporate events, hotel transportation, and local or outstation business travel."
},
{
"name": "IT Company Cab Service PCMC",
"description": "Choose IT Company Cab Service PCMC for reliable employee transportation to technology offices, business parks, and IT locations across Pimpri Chinchwad. Scheduled pickup and drop, professional chauffeurs, comfortable AC vehicles, and flexible shift routes support daily employee commuting."
},
{
"name": "Executive Cab Service Pimpri Chinchwad",
"description": "Book Executive Cab Service Pimpri Chinchwad for premium and comfortable transportation for senior executives, corporate clients, business guests, and management teams. Enjoy professional chauffeurs, well-maintained AC vehicles, convenient pickup and drop, airport transfers, meetings, hotels, and intercity business travel."
},
{
"name": "Corporate Cab Service PCMC",
"description": "Choose Corporate Cab Service PCMC for dependable employee and business transportation across Pimpri Chinchwad. The service supports office commuting, staff pickup and drop, executive travel, airport transfers, client transportation, corporate events, and scheduled local or outstation journeys."
}
],
"tableData": [
["Corporate Cab Service Pune", "Business Cab Service Pune"],
["Employee Transportation Pune", "Office Cab Service Pune"],
["Corporate Taxi Pune", "Company Cab Service Pune"],
["Staff Transportation Pune", "Corporate Cab Booking Pune"],
["Executive Cab Service Pune", "Corporate Travel Cab Pune"],
["Monthly Cab Service Pune", "Employee Pickup Drop Pune"],
["Corporate Fleet Pune", "Premium Corporate Cab Pune"],
["Office Commute Cab Pune", "Corporate Cab Services in Pune"],
["Corporate Taxi Service Pune", "Employee Transportation Service Pune"],
["Corporate Car Rental Pune", "Office Cab Service Pimpri Chinchwad"],
["Business Cab Service Pimpri Chinchwad", "Corporate Travel Service Pune"],
["Staff Pickup and Drop Service Pune", "Corporate Cab Booking Pune"],
["Best Corporate Cab Service in Pune", "Employee Transport Service Near Me Pune"],
["Office Pickup and Drop Cab Pune", "Corporate Taxi Booking Pune"],
["Business Travel Cab Service Pune", "Corporate Airport Cab Pune"],
["Cab Service for Companies Pune", "Staff Transportation in Pune"],
["Corporate Cab Service Pimpri Chinchwad", "Corporate Taxi Service PCMC"],
["Employee Transport Service Pimpri Chinchwad", "Office Cab Service Pimpri Chinchwad"],
["Corporate Car Rental PCMC", "Business Cab Service Pimpri Chinchwad"],
["Staff Transportation Service PCMC", "Corporate Cab Booking Pimpri Chinchwad"],
["IT Company Cab Service PCMC", "Executive Cab Service Pimpri Chinchwad"],
["Corporate Cab Service PCMC", ""]
],



whychoose: [
  {
    WhyChooseheading: "Corporate Cab Service in Pune for Professional Travel",
    WhyChoosedescription: "Garud Cab Service provides corporate cab solutions in Pune for employee transportation, client visits, business meetings, airport transfers, office travel, and other professional mobility requirements."
  },
  {
    WhyChooseheading: "Reliable Employee Transportation",
    WhyChoosedescription: "Companies can arrange dedicated cab services for employees travelling between their homes, offices, business parks, and other designated locations according to their work schedules."
  },
  {
    WhyChooseheading: "Business Meeting & Client Transfers",
    WhyChoosedescription: "Provide convenient transportation for clients, guests, executives, vendors, and visiting professionals travelling to offices, hotels, meeting venues, and business locations across Pune."
  },
  {
    WhyChooseheading: "Corporate Airport Transfer Support",
    WhyChoosedescription: "Arrange sedan and suitable premium vehicles for employee and client transfers to and from Pune Airport, helping businesses coordinate airport travel around scheduled flight timings."
  },
  {
    WhyChooseheading: "Multiple Vehicle Choices for Companies",
    WhyChoosedescription: "Select suitable vehicles according to passenger requirements, travel purpose, luggage, and group size, from comfortable sedans and SUVs to larger vehicles for employee or group transportation."
  },
  {
    WhyChooseheading: "Local & Outstation Corporate Travel",
    WhyChoosedescription: "Corporate cab arrangements can cover daily Pune travel as well as outstation business trips, site visits, conferences, client meetings, industrial visits, and company-related journeys."
  },
  {
    WhyChooseheading: "Flexible Booking for Business Schedules",
    WhyChoosedescription: "Plan transportation around office timings, meeting schedules, airport departures, employee shifts, and specific pickup or drop requirements to create a more convenient corporate travel arrangement."
  },
  {
    WhyChooseheading: "Dedicated Support from Garud Cab Service",
    WhyChoosedescription: "Share your company's transportation requirements, passenger details, routes, vehicle preferences, and travel schedules with Garud Cab Service to discuss a suitable corporate cab arrangement."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Corporate Cab Service in Pune?",
    answer: "Yes, Garud Cab Service provides corporate cab services in Pune for employee transportation, client transfers, airport travel, business meetings, office visits, and other professional requirements."
  },
  {
    question: "Can companies arrange employee transportation in Pune?",
    answer: "Yes, companies can arrange cab transportation for employees between their homes, offices, business parks, and other designated locations based on their travel schedules."
  },
  {
    question: "Can corporate cabs be used for client pickup?",
    answer: "Yes, corporate cab services can be arranged for client pickups, guest transportation, hotel transfers, office visits, meetings, and business events."
  },
  {
    question: "Does corporate cab service include Pune Airport transfers?",
    answer: "Yes, corporate airport transfers can be arranged for employees, executives, clients, and business guests travelling to or from Pune Airport."
  },
  {
    question: "Which vehicles are available for corporate travel?",
    answer: "Vehicle options can be selected according to the number of passengers, luggage, travel purpose, comfort requirements, and availability."
  },
  {
    question: "Can I book corporate cabs for outstation business trips?",
    answer: "Yes, corporate cab arrangements can be used for outstation meetings, site visits, conferences, industrial visits, client appointments, and other business travel."
  },
  {
    question: "Can companies book cabs for multiple employees?",
    answer: "Yes, transportation can be planned for multiple employees by selecting suitable vehicles and coordinating pickup and drop requirements."
  },
  {
    question: "Can corporate cab services be arranged according to office timings?",
    answer: "Yes, transportation schedules can be planned around office hours, employee shifts, meetings, airport schedules, and other company travel requirements."
  },
  {
    question: "Can businesses arrange regular cab transportation?",
    answer: "Yes, companies requiring recurring employee or business transportation can discuss regular cab requirements, routes, schedules, and vehicle preferences with Garud Cab Service."
  },
  {
    question: "How can I book Corporate Cab Service in Pune?",
    answer: "Share your company travel requirements, pickup and drop locations, passenger details, travel schedules, vehicle preferences, and service frequency with Garud Cab Service to discuss your booking."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Mehra",
    feedback: "We arranged corporate cabs for visiting clients in Pune. The private transportation was convenient for airport pickups, hotel transfers, and office meetings.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Priya Kulkarni",
    feedback: "Our team needed regular transportation for business travel around Pune. The cab arrangement made it easier to coordinate employee and meeting-related travel.",
    rating: 5
  }
];


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service Pune",
  "image": "https://garudcabs.com/assets/images/corporate-cab-service-pune.webp",
  "description": "Book Corporate Cab Service in Pune with Garud Cab for reliable employee transportation, business travel, office commuting, and corporate taxi requirements. Get dedicated company cab and staff transport solutions for daily employee pickup and drop, client meetings, airport transfers, and business trips with comfortable and well-maintained vehicles.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/corporate-cab-service-pune"
  }
};








  return (
    <div>
<Helmet>
  <title>Corporate Cab Service Pune | Employee & Office Taxi | +91 9970007784</title>

  <meta
    name="description"
    content="Get Corporate Cab Service in Pune with Garud Cab for employee transport, office commuting, business travel, and corporate taxi requirements. Reliable company cab and staff transportation services for daily pickup and drop, airport transfers, and business trips."
  />

  <meta
    name="keywords"
    content="Corporate cab service Pune, business cab service Pune, employee transport Pune, office cab service Pune, corporate taxi Pune, company cab service Pune, staff transportation Pune, employee cab service Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/49.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabservicepune;